export default function useClearPopUps() {
  const clearPopUps = (id) => {
    const popups = document.getElementsByClassName("mapboxgl-popup");
    const selectedPopUps = document.getElementById(id);
    if (popups.length) {
      if (selectedPopUps) {
        selectedPopUps.remove();
      } else {
        for (let i = 0; i < popups.length; i + 1) {
          popups[i].remove();
        }
      }
    }
  };
  return clearPopUps;
}
